import { notification } from 'ant-design-vue';

notification.config({ placement: 'bottomLeft' });

export default notification;
